import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {Button} from '../../../components/Button';
import { TextField } from '../../../components/TextField';
import {
    getUserNice,
    signup,
    userLogout,
} from '../../../apis/user';
import {AgreementType, Birth, SignupRequest, UserNiceDto} from '../../../types/types';
import { useHistory } from 'react-router-dom';
import { nToast } from '../../../plugins/reactToast';
import getUserOperatingSystem from '../../../utils/getUserOperatingSystem';
import { Bridge } from '../../../plugins/bridge';
import { AIRBRIDGE_EVENT } from '../../../constants/airbridge';
import { brazeGenderCode, BRAZE_EVENT } from '../../../constants/braze';
import { useUserState } from '../../../context/UserContext';
import KakaoPixel from '../../../plugins/kakao';
import { TargetingGates } from '../../../plugins/targetingGates';
import ReactPixel from '../../../plugins/facebookPixel';
import NaverPixel from '../../../plugins/naverPixel';
import gtag from '../../../plugins/gtag';
type SignupProps = {
    tokenVersionId: string
}
const Signup = ({tokenVersionId}: SignupProps) => {
    const form = useForm<SignupRequest>();
    const history = useHistory();
    const [birth, setBirth] = useState<Birth>({ year: '', month: '', day: '' });
    const [pass, setPass] = useState<string>('');
    const userState = useUserState();
    const [userNiceDto, setUserNiceDto] = useState<UserNiceDto | null>(null);

    useEffect(() => {
        const { isLoggedIn } = userState;

        if (isLoggedIn) {
            history.push('/');
            nToast('이미 로그인이 되어있습니다.');
        }
    }, [userState.isLoggedIn]);


    function leftPad(value: Number) {
        if (value >= 10) {
            return value;
        }
        return `0${value}`;
    }

    function toStringByFormatting(source: Date, delimiter = '-') {
        const year = source.getFullYear();
        const month = leftPad(source.getMonth() + 1);
        const day = leftPad(source.getDate());
        return [year, month, day].join(delimiter);
    }

    useEffect(() => {
        // 이전 토큰이 남아있는 경우가 있어서 확인사살..
        userLogout().catch(e => console.log('aleady louout'));
        const agreementMarketing = (localStorage.getItem('agreementMarketing') === '1')
        localStorage.removeItem('agreementMarketing')
        getUserNice(tokenVersionId).then(r => {
            const data = r.data.payload
            setUserNiceDto(r.data.payload)
            form.setValue('verificationNiceId', data.verificationNiceId)
            form.setValue('agreements', (agreementMarketing ?
                    [
                        AgreementType.SERVICE,
                        AgreementType.PRIVACY,
                        AgreementType.AGE,
                        AgreementType.SMS,
                        AgreementType.MAILING
                    ]
                    :
                    [
                        AgreementType.SERVICE,
                        AgreementType.PRIVACY,
                        AgreementType.AGE
                    ]
            ));
            form.setValue('platform', getUserOperatingSystem(window.navigator));
            form.setValue('source', 'CARHARTT');

            const birth = data.userBirth.split('-')
            if(birth.length == 3){
                setBirth({
                    year: birth[0],
                    month: birth[1],
                    day: birth[2]
                })
            }
        }).catch(
            err => {
                if(err.response?.data.message)
                    nToast(err.response?.data.message)
                else
                    nToast("에러가 발생하였습니다. 고객센터에 문의해주세요.")
            }
        )

    }, []);

    useEffect(() => {
        KakaoPixel.Participation();
    }, []);

    const userSetting = async (r: any, data: SignupRequest) => {
        if (!userNiceDto) return;
            const braze_option = {
                firstName: userNiceDto.userName,
                email: data.email,
                PhoneNumber: userNiceDto.userPhone,
                year: parseInt(birth.year),
                month: parseInt(birth.month),
                day: parseInt(birth.day),
                gender: brazeGenderCode(userNiceDto.userGender ?? ''),
                EmailNotificationSubscriptionType: data.agreements?.find(
                    item => item === 'MAILING',
                )
                    ? 'opted_in'
                    : 'unsubscribed',
                PushNotificationSubscriptionType: data.agreements?.find(
                    item => item === 'SMS',
                )
                    ? 'opted_in'
                    : 'unsubscribed',
                customUserAttribute: {
                    sign_up_date: new Date(),
                    WO_membership: 'BASIC',
                    account_status: '등록',
                },
                userId: r.data.payload?.userId.toString(),
            };
            Bridge.sendBraze('brazeSetting', braze_option);

        Bridge.sendBraze(BRAZE_EVENT.SIGN_UP);
        const option = {
            userAttribute: {
                userID: r.data.payload.userId.toString(),
                userEmail: data.email,
                userPhone: userNiceDto.userPhone,
                gender: userNiceDto.userGender,
                birthyear: userNiceDto.userBirth,
            },
        };

        Bridge.sendAirbridge(AIRBRIDGE_EVENT.signUp, undefined, option);
        TargetingGates.sendSignUp({ email: data.email });

        const currentTime = new Date();

        const signup_option = {
            // @ts-ignore
            first_name: data.name,
            email: data.email,
            gender: userNiceDto.userGender,
            phone: userNiceDto.userPhone,
            dob: toStringByFormatting(new Date(userNiceDto.userBirth)),
            age: currentTime.getFullYear() - Number(birth.year) + 1,
            birth_year: Number(birth.year),
            sign_up_date: toStringByFormatting(currentTime),
            sign_up_year: currentTime.getFullYear(),
            sign_up_month: currentTime.getMonth() + 1,
            sign_up_day: currentTime.getDate(),
            stage_of_email_on: !!data.agreements.find(item => item == 'MAILING'),
            stage_of_sms_push_on: !!data.agreements.find(item => item == 'SMS'),
            membership: r.data.payload?.userGrade.toString(),
        };

        await Bridge.sendAmplitude('sign_up_completed', {
            userId: r.data.payload?.userId.toString(),
            platform: 'CH',
            option: signup_option,
        });
        await Bridge.sendAmplitude('setUserId', null);
    };

    const handleSignup = (data: SignupRequest) => {
        if (pass === form.watch().password && form.watch().email) {
            signup(data)
                .then(async r => {
                    await userSetting(r, data);
                    ReactPixel.lead();
                    NaverPixel.lead();
                    //Logger.lead();

                    gtag.ads.conversionActions.join();
                    gtag.ads.conversionActions.signUp();
                    KakaoPixel.CompleteRegistration();

                    history.push('/signup/success');
                })
                .catch(e => {
                    if (e.response.data.message) {
                        nToast(e.response.data.message);
                    } else {
                        nToast('에러가 발생했습니다. 고객센터에 문의해주세요.');
                    }
                });
        } else {
            nToast('정보를 모두 입력해 주세요');
        }
    };

    const getGender = (userGender: string) => {
        switch (userGender) {
            case 'MALE':
                return '남성';
            case 'FEMALE':
                return '여성';
            case 'ETC':
                return '선택 안 함';
            default:
                return '선택 안 함';
        }
    };

    return (
        <div className="mx-auto mb-20 w-full space-y-4">
            <h4 className={`text-14`}>계정 정보 입력</h4>
            <p className={`text-12 leading-5`}>
                고객님이 사용하실 계정 정보를 입력해주세요.
            </p>
            <form
                className="flex flex-col space-y-6"
                onSubmit={form.handleSubmit(handleSignup)}>
                <TextField
                    label="이름"
                    value={userNiceDto?.userName}
                    disabled
                />
                <TextField
                    label="성별"
                    className="border pl-4"
                    value={getGender(userNiceDto?.userGender ?? '')}
                    disabled
                />
                <TextField
                    label="생년월일"
                    value={userNiceDto?.userBirth}
                    disabled
                />
                <TextField
                    label="핸드폰번호"
                    value={userNiceDto?.userPhone}
                    disabled
                />
                <TextField
                    type="email"
                    label="아이디 (이메일)"
                    placeholder="이메일을 입력해주세요."
                    helper={form.formState.errors.email?.message}
                    {...form.register('email', { required: '이메일을 입력해주세요.' })}
                />

                <TextField
                    type="password"
                    label="비밀번호"
                    helper={form.formState.errors.password?.message}
                    defaultValue={''}
                    {...form.register('password', {
                        required: '비밀번호를 입력해주세요',
                        minLength: { value: 8, message: '최소 8자 이상 가능합니다' },
                        maxLength: { value: 15, message: '최대 15자 까지만 가능합니다' },
                    })}
                />
                <TextField
                    type="password"
                    label="비밀번호 확인"
                    helper={
                        pass.length > 0 && form.watch().password !== pass
                            ? '비밀번호가 일치하지 않습니다'
                            : ''
                    }
                    onChange={e => setPass(e.target.value)}
                />

                <div className="border-b border-gray-100" />

                <Button
                    type={'submit'}
                    disabled={
                        form.watch('password') !== pass ||
                        !form.watch('password') ||
                        !form.watch('email')
                    }
                    text="통합 회원가입"
                    className="filled-brand-1"
                />
            </form>
        </div>
    );
};

export default Signup
